import { render, staticRenderFns } from "./bread-crumb-component.vue?vue&type=template&id=1bb45ced"
import script from "./bread-crumb-component.vue?vue&type=script&lang=js"
export * from "./bread-crumb-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports